export default "/images/vendor/flag-icon-css/flags/4x3/mk.svg?31ba11ec4d4cdae74ebc0cbc1b768f44";